<style lang="scss" scoped>
.version {
  font-size: 15px;
}
</style>

<template>
  <v-app id="inspire">
    <v-content>
      <v-container class="fill-height" fluid style="background-color: #f1f1f1">
        <v-row align="center" justify="center" no-gutters>
          <v-col>
            <ValidationObserver ref="forms" v-slot="{}">
              <v-form @submit.prevent="login">
                <v-card style="max-width: 400px" elevation="7" class="mx-auto">
                  <v-row class="text-center pt-5">
                    <v-col>
                      <h1>
                        <v-img
                          src="@/assets/logo_dark.svg"
                          height="60"
                          contain
                          alt="Brastop"
                          class="text-center"
                        ></v-img>
                      </h1>
                    </v-col>
                  </v-row>
                  <v-card-text class="m-15">
                    <ValidationProvider
                      name="email"
                      rules="required|email"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        label="Email"
                        name="email"
                        prepend-inner-icon="mdi-account"
                        type="email"
                        v-model="email"
                        :error-messages="errors"
                        :disabled="loading"
                      />
                    </ValidationProvider>

                    <ValidationProvider
                      name="senha"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        id="password"
                        label="Senha"
                        name="password"
                        prepend-inner-icon="mdi-lock"
                        v-model="password"
                        :error-messages="errors"
                        :disabled="loading"
                        :type="show ? 'text' : 'password'"
                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="show = !show"
                      />
                    </ValidationProvider>

                    <v-alert
                      type="error"
                      class="mt-2"
                      v-if="message"
                      text
                      icon="mdi-message-alert-outline"
                      >{{ message }}</v-alert
                    >
                  </v-card-text>

                  <v-card-actions>
                    <v-row>
                      <v-col class="text-center">
                        <v-btn
                          type="submit"
                          color="primary"
                          tile
                          :loading="loading"
                        >
                          Iniciar sessão
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                  <v-row>
                    <v-col class="text-center">
                      <span class="text-center font-weight-normal version">
                        Versão {{ $store.getters.getAppVersion }}
                      </span>
                    </v-col>
                  </v-row>

                </v-card>
              </v-form>
            </ValidationObserver>
          </v-col>
        </v-row>
      </v-container>
      <v-footer absolute>
        <v-col class="text-center" cols="12">
          <span>Powered by</span>
          <b> Core Coding</b> &copy;{{ new Date().getFullYear() }}
        </v-col>
      </v-footer>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "login",
  props: ["external_message"],
  data: () => ({
    email: "",
    password: "",
    loading: false,
    show: false,
    message: ""
  }),
  methods: {
    login() {
      this.$refs.forms.validate().then(r => {
        if (r) {
          this.loading = true;
          this.message = "";

          // O cookie XSRF-TOKEN vem antes do login; o axios o devolve no header X-XSRF-TOKEN.
          this.$http
            .get("/sanctum/csrf-cookie")
            .then(() =>
              this.$http.post("/auth/login", {
                email: this.email,
                password: this.password
              })
            )
            .then(response => {
              this.loading = false;

              if (response.data.success) {
                this.$store
                  .dispatch("login", { user: response.data.user })
                  .then(() => {
                    const from = this.$route.query.from || "";
                    // Páginas do Laravel (o painel do Pulse) ficam fora do SPA.
                    if (/^\/pulse(\/|\?|$)/.test(from)) {
                      window.location.href = from;
                    } else if (from) {
                      this.$router.push(this.$route.query.from);
                    } else {
                      this.$router.push({ name: "dashboard" });
                    }
                  });
              } else {
                this.message = response.data.message;
                this.password = "";

                this.$refs.forms.reset();
              }
            })
            .catch(error => {
              // 429: muitas tentativas de login.
              this.loading = false;
              this.message =
                (error.response && error.response.data.message) ||
                "Não foi possível fazer login. Tente novamente.";
              this.password = "";
            });
        } else {
          this.message = "";
        }
      });
    }
  },
  created() {
    this.$store.dispatch("logout");
    this.message = this.$store.getters.getMessage;
  }
};
</script>

<style lang="scss">
.login {
  .card-text {
    padding: 10px;
  }
}
</style>
